module.exports = __webpack_public_path__ + "img/Pic_Text_ZBT.304297d6.png";